import { format } from 'date-fns';
import { CommonExport } from '../common/common-export.service';

export class SubOrderExportService extends CommonExport<any> {
  subOrdersExportToExcel = (filters: any, search: string, path: string | undefined) => {
    const time = format(new Date(), 'dd-MM-yyyy');
    const filename = `suborders-${time}.xlsx`;
    const basePath = '/excel/sub-orders';
    const exportUrl = path ? `${basePath}/${path}` : basePath;
    return this._downloadDocument(exportUrl, filename, filters, search);
  };

  subOrdersExportToExcelForDrivers = (filters: any, search: string) => {
    const time = format(new Date(), 'dd-MM-yyyy');
    const name = `suborders-${time}.xlsx`;
    return this._downloadDocument('/excel/sub-orders-drivers', name, filters, search);
  };

  subscriptionsExportToExcel = (filters: any, search: string) => {
    const time = format(new Date(), 'dd-MM-yyyy');
    const name = `subscriptions-${time}.xlsx`;
    return this._downloadDocument('/excel/subscriptions', name, filters, search);
  };

  subOrdersExportToXML = (filters: any, search: string) => {
    const time = format(new Date(), 'dd-MM-yyyy');
    const name = `suborders-${time}.xml`;
    return this._downloadDocument('/xml/sub-orders', name, filters, search);
  };

  /* export suborder to pdf */
  subOrderExportToPDF = (filters?: any) => this._exportToPDF({ filters, path: '/pdfBulk', name: 'suborders-users' });

  /* export invoice pdf bulk */
  subOrderExportToPDFBulkInvoice = (filters?: any) =>
    this._exportToPDF({ filters, path: '/invoices/pdfBulk?admin=true', name: 'suborders' });

  /* export delivery ticket */
  subOrderTicketDeliveryExport = (filters?: any) =>
    this._exportToPDF({ filters, path: '/ticket-delivery/?admin=true', name: 'ticket' });

  piadOrderInvoiceExportToExcel = (filters: any, search: string) => {
    const time = format(new Date(), 'dd-MM-yyyy');
    const name = `piad-order-invoice-${time}.xlsx`;
    return this._downloadDocument('/excel/piad-orders', name, filters, search);
  };
}

export default new SubOrderExportService('/ms-exports');
